import React, { useState } from 'react';
import { connect } from 'react-redux';
import Icon from 'chameleon/packages/blue-book-player/library/icon';
import DecorativeBorder from 'chameleon/packages/blue-book-player/DecorativeBorder';
import QuestionNavigator from 'chameleon/packages/blue-book-player/library/QuestionNavigator';
import QuestionNavigatorPreview from 'chameleon/packages/blue-book-player/library/QuestionNavigatorPreview';
import NavigationContainer from './NavigationContainer';
import { getIndexOfSingleQuestionPreview } from 'chameleon/packages/blue-book-player/utils';
import CheckAnswerButton from '../CheckAnswerButton';
import useIsChromebook from '../hooks/useIsChromebook';

import './index.scss';

const FooterContainer = (props) => {
  const {
    learnosityApp,
    learnosityItems,
    userData: { isImpersonating },
    isSingleQuestionPreview,
    isPreviewPlayer,
    previewData,
    render,
    immediateFeedbackFF,
    playerState,
    isDigitalExam,
    onItemChange,
    isSecure,
  } = props;
  const [questionCurrentIndex, setQuestionCurrentIndex] = useState(() => {
    if (isSingleQuestionPreview && previewData) {
      return getIndexOfSingleQuestionPreview(previewData);
    }
    return null;
  });

  const isChromebook = useIsChromebook();

  const handleItemChange = (index) => {
    const { itemsPerPage, currentPage, items } = previewData;
    const currentItemId = items[index - 1]?.item_id;
    if (currentItemId && onItemChange) {
      onItemChange(currentItemId);
    }
    setQuestionCurrentIndex(itemsPerPage * currentPage + index);
  };

  return (
    <div
      className={`bluebook-player-footer flex flex-column w-full grow-0 shrink-0 bb-desktop:basis-[80px] bg-bluebook-blue1 h-[80px] z-belowModals
      bb-mobile:h-auto ${isChromebook && isSecure ? 'footer-float' : ''}`}
      data-cy="footer"
    >
      <DecorativeBorder segmentNr={56} />
      <div className="bb-mobile:block bb-desktop:hidden px-4">
        {playerState.assignment?.hasImmediateFeedback &&
          props.immediateFeedbackFF &&
          learnosityApp?.getCurrentItem?.() && (
            <CheckAnswerButton
              app={learnosityApp}
              isImpersonating={isImpersonating}
              immediateFeedbackAttempts={
                playerState.assignment?.immediateFeedbackAttempts
              }
              className="w-full mt-3 check-answer-button"
              containerClassName="w-full justify-between"
            />
          )}
      </div>
      <div
        className={`w-full h-full bb-desktop:h-[60px] flex justify-between items-center bb-desktop:px-[42px] bb-desktop:pt-[18px] bb-mobile:px-4 ${isChromebook && isSecure ? 'align-start' : ''}`}
      >
        <div
          className="flex grow basis-0 items-center bb-mobile:hidden"
          data-cy="apc-logo"
        >
          <Icon id="logo" className="fill-black" />
          <Icon id="apc" className="fill-black ml-5" />
        </div>
        {learnosityApp && questionCurrentIndex !== null ? (
          <QuestionNavigatorPreview
            questionCurrentIndex={questionCurrentIndex}
            total={previewData.total}
          />
        ) : (
          <QuestionNavigator learnosityApp={learnosityApp} />
        )}
        {learnosityApp && isSingleQuestionPreview ? (
          render({
            learnosityApp,
            learnosityItems,
            onItemChange: handleItemChange,
          })
        ) : (
          <NavigationContainer
            learnosityApp={learnosityApp}
            isImpersonating={isImpersonating}
            isPreviewPlayer={isPreviewPlayer}
            immediateFeedbackFF={immediateFeedbackFF}
            isDigitalExam={isDigitalExam}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  immediateFeedbackFF: state.featureFlag.immediate_feedback,
});

export default connect(mapStateToProps)(FooterContainer);
